import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOngoing = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22.715 10.4119C23.1011 10.8068 23.094 11.4399 22.6991 11.826L20.8809 13.6038C20.4923 13.9838 19.8713 13.9838 19.4827 13.6038L17.6645 11.826C17.2696 11.4399 17.2625 10.8068 17.6486 10.4119C18.0065 10.0459 18.5766 10.013 18.9725 10.3176C18.2013 7.27601 15.3869 5 12 5C10.0092 5 8.2127 5.788 6.91369 7.05815C6.51881 7.44426 5.88568 7.43715 5.49957 7.04227C5.11346 6.64738 5.12057 6.01425 5.51546 5.62814C7.17767 4.00286 9.47206 3 12 3C16.5738 3 20.3948 6.2885 21.0743 10.6175L21.3009 10.396C21.6958 10.0099 22.3289 10.017 22.715 10.4119ZM18.5004 16.9577C18.8865 17.3526 18.8794 17.9857 18.4845 18.3719C16.8223 19.9971 14.5279 21 12 21C7.42617 21 3.60513 17.7115 2.92559 13.3825L2.69912 13.6039C2.30423 13.99 1.67111 13.9829 1.285 13.588C0.898882 13.1931 0.905995 12.56 1.30088 12.1739L3.11906 10.3961C3.50768 10.0161 4.12867 10.0161 4.51729 10.3961L6.33546 12.1739C6.73035 12.56 6.73746 13.1931 6.35135 13.588C5.99346 13.954 5.42334 13.9869 5.02744 13.6822C5.79853 16.7239 8.613 19 12 19C13.9907 19 15.7872 18.212 17.0862 16.9418C17.4811 16.5557 18.1142 16.5628 18.5004 16.9577Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 7C12.5523 7 13 7.44772 13 8V11.5858L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12V8C11 7.44772 11.4477 7 12 7Z",
		fill: "currentColor"
	})]
});
export default SvgOngoing;
